import { createSlice } from "@reduxjs/toolkit";

const walkerSlice = createSlice({
  name: "walker",
  initialState: [],
  reducers: {
    walkerAdded(state, action) {
      return action.payload;
    },
  },
});

export const { walkerAdded } = walkerSlice.actions;
export default walkerSlice.reducer;
